import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("udp_cookies_ack") !== "1") {
      const t = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("udp_cookies_ack", "1");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 right-4 md:right-6 left-4 md:left-auto z-[90] md:max-w-md glass-strong rounded-2xl p-5 border border-[#c5a059]/30"
    >
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-full bg-[#c5a059]/15 flex items-center justify-center shrink-0">
          <Cookie size={18} className="text-[#c5a059]" />
        </div>
        <div className="flex-1">
          <div className="text-sm font-semibold text-white mb-1">We use cookies</div>
          <p className="text-xs text-white/60 leading-relaxed">
            We use essential and analytics cookies to improve your experience and understand how the
            site is used. See our{" "}
            <Link to="/privacy" className="text-[#c5a059] hover:underline" data-testid="cookie-privacy-link">
              Privacy Policy
            </Link>
            .
          </p>
          <div className="flex items-center gap-3 mt-3">
            <button
              onClick={accept}
              className="btn-premium px-4 py-2 rounded-md text-[11px] font-bold tracking-[0.2em]"
              data-testid="cookie-accept-btn"
            >
              ACCEPT
            </button>
            <button
              onClick={accept}
              className="text-[11px] tracking-[0.2em] uppercase text-white/50 hover:text-white"
              data-testid="cookie-decline-btn"
            >
              Decline non-essential
            </button>
          </div>
        </div>
        <button
          onClick={accept}
          className="text-white/40 hover:text-white shrink-0"
          aria-label="Close"
          data-testid="cookie-close"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
};
